<div class="modal-container">
  <span (click)="cancel()" class="close">X</span>
  <div *ngIf="!delProduct; else deleteTemplate" class="form-container">
    <form #productForm="ngForm" (ngSubmit)="submitForm(productForm)" novalidate>
      <div>
        <label for="name">Product name</label>
        <input
          type="text"
          id="name"
          [(ngModel)]="editProduct ? editProduct.name : form.name"
          name="name"
          #name="ngModel"
          [class.inputerror]="isFormSubmitted && name.invalid"
          required
        />
        <p class="error" *ngIf="isFormSubmitted && name.invalid">
          Required Field.
        </p>
      </div>
      <div>
        <label for="price"> Price</label>
        <input
          type="number"
          id="price"
          [(ngModel)]="editProduct ? editProduct.price : form.price"
          #price="ngModel"
          [class.inputerror]="isFormSubmitted && price.invalid"
          name="price"
          required
          min="1"
        />
        <p
          class="error"
          *ngIf="isFormSubmitted && price.invalid && price.touched"
        >
          Required Field & must be a valid price.
        </p>
      </div>
      <div>
        <label for="image">Image URL</label>
        <input
          type="text"
          id="image"
          [(ngModel)]="editProduct ? editProduct.image : form.image"
          #image="ngModel"
          [class.inputerror]="isFormSubmitted && image.invalid"
          name="image"
          required
        />
        <p class="error" *ngIf="isFormSubmitted && image.invalid">
          Required Field.
        </p>
      </div>
      <div>
        <label for="description">Description</label>
        <textarea
          name="description"
          [(ngModel)]="editProduct ? editProduct.description : form.description"
          required
          #description="ngModel"
          [class.inputerror]="isFormSubmitted && description.invalid"
          id=""
          cols="48"
          rows="10"
        ></textarea>
        <p class="error" *ngIf="isFormSubmitted && description.invalid">
          Required Field.
        </p>
      </div>
      <div class="btn-container">
        <button class="btn-mode" type="button" (click)="cancel()">
          Cancel
        </button>
        <button type="submit" class="btn-primary">
          {{
            editProduct
              ? loading
                ? "Saving.."
                : "Edit & save"
              : loading
              ? "Saving.."
              : "Save"
          }}
        </button>
      </div>
    </form>
  </div>
  <ng-template #deleteTemplate>
    <div class="del-container">
      <h2>Delete Confirmation</h2>
      <h4>Are you sure want to delete "{{ delProduct.name }}"</h4>
      <div class="del-controls">
        <button class="btn-cancel" (click)="cancel()">Cancel</button>
        <button class="btn-delete" (click)="delConfirm()">
          {{ loading ? "Deleting.." : "Delete" }}
        </button>
      </div>
    </div>
  </ng-template>
</div>
